'use strict'

export default (mockAxios) => {
  mockAxios.onGet('/announcements').reply((config) => {
    const params = config.params || {}

    if (params.count === '1') {
      return [200, {
        'success': true,
        'data': {
          'count': 2
        }
      }]
    }

    // unread
    let data = [
      {
        'id': '1j904odnk2qq',
        'title': '2021年 新年のご挨拶',
        'formatted_date_from': '2020/01/01',
        'formatted_date_to': '2120/01/31',
        'unread': '1',
        'created': '2020/11/01 01:02:03',
        'updated': '2020/11/01 01:02:03'
      },
      {
        'id': 'f9083f8bjhvs',
        'title': '【名刺バンク２】規約改定のお知らせ',
        'formatted_date_from': '2020/01/01',
        'formatted_date_to': '',
        'unread': '1',
        'created': '2020/01/01 01:02:03',
        'updated': '2020/01/02 01:02:03'
      }
    ]

    // read
    if (params.unread !== '1') {
      data.push({
        'id': '6t7g3b327j38',
        'title': '〇〇〇〇の不具合により、通信障害が発生している件についての長い長いお知らせタイトルタイトル',
        'formatted_date_from': '',
        'formatted_date_to': '2120/11/03',
        'unread': '0',
        'created': '2020/01/01 01:02:03',
        'updated': '2020/01/01 01:02:03'
      })
    }

    return [200, {
      'success': true,
      data
    }]
  })

  mockAxios.onGet(new RegExp(`/announcements/\\d+`)).reply((config) => {
    return [200, {
      'success': true,
      data: {
        'id': '1j904odnk2qq',
        'title': '2021年 新年のご挨拶',
        'body': '2021年 新年のご挨拶\n\n旧年中は格別のご高配を賜り、深く感謝申し上げます。\n\n本年も旧年同様、一層のサービス向上を目指す所存です。\n何卒よろしくお願い申し上げます。\n\n2021年元旦\n\nスタッフ一同\n住所・電話番号',
        'formatted_date_from': '2020/01/01',
        'formatted_date_to': '2020/01/31',
        'created': '2018/01/01 00:00',
        'updated': '2018/01/01 00:00'
      }
    }]
  })

  mockAxios.onPut(new RegExp(`/announcements/read/\\d+`)).reply((config) => {
    return [200, {
      'success': true,
      data: []
    }]
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/announcementRepositoryMock.js